<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot-scope="props" slot="links">
        <sidebar-item :link="{name: 'Dashboard', icon: 'fa fa-fw fa-home', path: '/admin/overview'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Articles', icon: 'fa fa-fw fa-file-text-o', path: '/admin/stories'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'À la une', icon: 'fa fa-fw fa-th-large', path: '/admin/home'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Rédacteurs', icon: 'fa fa-fw fa-users', path: '/admin/authors'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Tags', icon: 'fa fa-fw fa-tags', path: '/admin/tags'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Dossiers', icon: 'fa fa-fw fa-folder-open', path: '/admin/topics'}">
        </sidebar-item>
      </template>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
    <auth-layout pageClass="lock-page" v-if="globalsLocked">
      <div class="content">
        <form method="#" action="#">
          <div class="user-profile">
            <div class="author">
              <img class="avatar" src="/static/img/faces/face-0.jpg" alt="...">
            </div>
            <h4>{{ $auth.user().screenname }}</h4>
            <fg-input type="password" placeholder="Enter Password"></fg-input>
            <button type="button" class="btn btn-round btn-info btn-wd">Unlock</button>
          </div>
        </form>
      </div>
    </auth-layout>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AuthLayout from './../AuthLayout.vue'
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './Extra/MobileMenu.vue'
import UserMenu from './Extra/UserMenu.vue'


export default {
  computed: mapGetters({
    globalsLocked: 'globalsLocked'
  }),
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu,
    AuthLayout
  },
  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}

</script>
